import { ComponentType, ReactElement, useState } from 'react'
import styleUtils from 'shared-components/styles/util.module.css'
import { DSNCTabs, DSResource, DSTpl, NCComponentInterface } from 'shared-definitions/types'
import clsx from 'clsx'
import styles from './NCTabs.module.css'
import HorizontalTabs from '../ui/HorizontalTabs'
import ControlledSlider from '../service/ControlledSlider'

interface NCTabsProps<T extends DSResource> {
  data: DSNCTabs<T>
  tpl: DSTpl
  nc: ComponentType<NCComponentInterface<T>>
}

const NCTabs = <T extends DSResource>({ data, nc: NC, tpl }: NCTabsProps<T>): ReactElement => {
  const [currentTabKey, setCurrentTabKey] = useState(0)

  return (
    <div className={clsx(styles.container, styleUtils.nc)}>
      <HorizontalTabs
        tabs={data.tabs.map((i, index) => ({
          label: i.title,
          key: index,
        }))}
        currentTabKey={currentTabKey}
        onTabChange={setCurrentTabKey}
      />
      <ControlledSlider
        className={styles.tabList}
        items={data.tabs}
        render={item => (
          <>
            {item.content.map((contentItem, contentIndex) => (
              <NC index={contentIndex} key={contentIndex} data={contentItem} tpl={tpl} />
            ))}
          </>
        )}
        isActiveItem={(_, index) => index === currentTabKey}
      />
    </div>
  )
}

export default NCTabs
